import React, { useState } from 'react';
import { ADMIN_ROLE, USER_ROLE, UserDto } from '../../models/user.dto';
import { useTranslation } from 'react-i18next';
import { NavDropdown, Table } from 'react-bootstrap';
import { PersonDash, PersonGear } from 'react-bootstrap-icons';
import './profile-users.scss';
import AdminDialog from './admin-dialog/admin-dialog';
import DeleteUserDialog from './delete-user-dialog/delete-user-dialog';
import { isKeycloakIDP } from '../../utils/loginProvider';
import teamMemberActionsIcon from '../../assets/icons/team-member-actions.svg';

type ProfileInfoProps = {
   users: UserDto[];
   currentUser?: UserDto;
};

const ProfileUsers = ({ users, currentUser }: ProfileInfoProps) => {
   const [translate] = useTranslation(['account', 'common']);
   const [adminModal, setAdminModal] = useState<{ email: string } | undefined>(undefined);
   const [deleteUserEmail, setDeleteUserEmail] = useState<string | undefined>(undefined);
   const canDeleteUsers = isKeycloakIDP && currentUser?.role === ADMIN_ROLE;

   const columns = ['user', 'email', 'role'];

   const capitalizeFirstLetter = (text: string) => text.charAt(0).toUpperCase() + text.slice(1);

   return (
      <section className='profile-card team-members-card'>
         <Table className='custom-table profile-table'>
            <colgroup>
               <col className='team-user-column' />
               <col className='team-email-column' />
               <col className='team-role-column' />
               <col className='team-actions-column' />
            </colgroup>
            <thead>
               <tr>
                  <th colSpan={4}>
                     Team members
                  </th>
               </tr>
               <tr className='header-row'>
                  {columns.map((c, index) => (
                     <th key={index}>
                        {capitalizeFirstLetter(translate(`account:${c}`))}
                     </th>
                  ))}
                  <th aria-label='Actions'></th>
               </tr>
            </thead>
            <tbody>
               {users.map((user, index) => (
                  <tr key={index}>
                     <td>{`${user.firstName} ${user.lastName || ''}`.trim()}</td>
                     <td>{user.email}</td>
                     <td><span className='user-role'>{user.role === ADMIN_ROLE ? ADMIN_ROLE : 'USER'}</span></td>
                     <td className='team-member-actions'>
                        {canDeleteUsers && user.role === USER_ROLE &&
                           user.email.trim().toLowerCase() !== currentUser?.email.trim().toLowerCase() && (
                           <NavDropdown align='end' title={(
                              <>
                                 <span className='team-member-actions-icon' aria-hidden='true'>
                                    <img src={teamMemberActionsIcon} alt='' />
                                 </span>
                                 <span className='visually-hidden'>{`Actions for ${user.email}`}</span>
                              </>
                           )}>
                              <NavDropdown.Item onClick={() => setAdminModal({ email: user.email })}>
                                 <PersonGear /> {translate('common:common.convertToAdmin')}
                              </NavDropdown.Item>
                              <NavDropdown.Item className='text-danger' onClick={() => setDeleteUserEmail(user.email)}>
                                 <PersonDash /> {translate('common:common.delete')}
                              </NavDropdown.Item>
                           </NavDropdown>
                        )}
                     </td>
                  </tr>
               ))}
            </tbody>
         </Table>
         <AdminDialog
            show={adminModal != undefined}
            onHide={() => setAdminModal(undefined)}
            userEmail={adminModal?.email ?? ''}
         />
         {deleteUserEmail && (
            <DeleteUserDialog
               userEmail={deleteUserEmail}
               onHide={() => setDeleteUserEmail(undefined)}
            />
         )}
      </section>
   );
};

export default ProfileUsers;
